/* FM related-products strip — cursor chip with product name + price on hover,
   mirroring the Gallery Alt carousel's cursor card. The card's own text is
   hidden by CSS but stays in the DOM; the chip reads it from there. */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var grid = document.querySelector("main[data-template='product'] .related-products");
  if (!grid) return;

  var chip = document.createElement('div');
  chip.className = 'fm-cursor';
  chip.setAttribute('aria-hidden', 'true');
  var title = document.createElement('span');
  title.className = 'fm-cursor__title';
  var price = document.createElement('span');
  price.className = 'fm-cursor__price';
  chip.append(title, price);
  document.body.appendChild(chip);

  var active = null;

  grid.addEventListener('mousemove', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card) {
      chip.dataset.visible = 'false';
      active = null;
      return;
    }
    if (card !== active) {
      active = card;
      var h = card.querySelector('.card__heading');
      var p = card.querySelector('.price-item--regular') || card.querySelector('.price');
      title.textContent = h ? h.textContent.trim() : '';
      price.textContent = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    chip.style.transform = 'translate3d(' + (e.clientX + 14) + 'px, ' + (e.clientY + 16) + 'px, 0)';
    chip.dataset.visible = 'true';
  });

  grid.addEventListener('mouseleave', function () {
    chip.dataset.visible = 'false';
    active = null;
  });
})();
